export const KYBRiskViewLabel = {
	riskDecision: 'Risk Decision',
	riskScore: 'Risk Score',
	riskLevel: 'Risk Level',
	riskScoreEngineId: 'Risk Score Engine ID',
	riskTitle: 'Risk Title',
};